<div class="relative">
    <input
        #inputRef
        [value]="value() || null"
        class="w-full bg-zinc-800 pl-3 pr-10 py-2.5 h-12 text-sm font-medium text-zinc-500 border border-zinc-700 placeholder:text-zinc-500 placeholder:font-normal placeholder:text-sm"
        [placeholder]="placeholder() || '검색어를 입력해주세요.'"
        [spellcheck]="spellcheck()"
        [autocomplete]="autocomplete()"
        [autofocus]="autofocus()"
        [readOnly]="readonly()"
        [maxLength]="maxlength() || 524288"
        (click)="inputClick.emit()"
        (focus)="inputFocus.emit()"
        (blur)="inputBlur.emit()"
        type="text"
        [ngClass]="[width() || 'xl:min-w-[370px]', round() || 'rounded-full']"
    />

    <button
        (click)="search()"
        class="rounded-full absolute z-10 pb-0.5 size-6 flex items-center justify-center -translate-y-1/2 cursor-pointer right-3 top-1/2 bg-primary transition-all duration-300 hover:opacity-90"
    >
        <img [draggable]="false" alt="searchIcon" src="icons/search.svg" class="size-3.5" />
    </button>
</div>
